import 'slick-carousel/slick/slick'

export default class NewsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-news-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                slidesToShow: 3,
                slidesToScroll: 3,
                prevArrow: $('.js-news-slider-previous'),
                nextArrow: $('.js-news-slider-next'),
                dots: true,
                appendDots: $('.js-news-slider-dots'),

                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });

            // Disable previous button on first slide and next button on last slide

            this.settings.$slider.on('afterChange', function(slick, currentSlide){
                const $previous = $('.js-news-slider-previous');
                const $next = $('.js-news-slider-next');
                const slideNr = $('[data-slides-number]').text();
                const slideNrMobile = $('[data-slides-number-mobile]').text();

                if(currentSlide !== 0) {
                    $previous.removeClass('opacity-30 cursor-default');
                    $previous.prop('disabled', false);
                } else {
                    $previous.addClass('opacity-30 cursor-default');
                    $previous.prop('disabled', true);
                }

                if ($(window).width() < 1024) {
                    if(currentSlide === slideNrMobile-1) {
                        $next.addClass('opacity-30 cursor-default');
                        $next.prop('disabled', true);
                    } else {
                        $next.removeClass('opacity-30 cursor-default');
                        $next.prop('disabled', false);
                    }
                }
                else {
                    if(currentSlide/3 === slideNr-1) {
                        $next.addClass('opacity-30 cursor-default');
                        $next.prop('disabled', true);
                    } else {
                        $next.removeClass('opacity-30 cursor-default');
                        $next.prop('disabled', false);
                    }
                }
            });
            
            const updateSlideIndex = () => {
                $('[data-slide-index]').text((this.settings.$slider.slick('slickCurrentSlide')/3+1));
                $('[data-slide-index-mobile]').text((this.settings.$slider.slick('slickCurrentSlide')+1));
            }

            updateSlideIndex();
            this.settings.$slider.on('afterChange', updateSlideIndex);
        }

    }

};

new NewsSlider();